module.exports = __webpack_public_path__ + "static/img/iphone_4.efd1922.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_4.png
// module id = 48Wt
// module chunks = 0